import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'shared/hooks/useRouterPath';
import { isCopilotFullscreenChatPath } from 'shared/copilot/utils/fullscreenChatRoute';

/**
 * True when the user is on the full-page Alvie AI Pro chat route
 * (`/ai/chat` or `/ai/chat/<chat_id>`).
 * Page-context drawer tools (inspect/highlight against the surrounding Alvie screen)
 * are not meaningful there.
 */
export const useIsCopilotStandaloneChatPage = () => {
  const $ = _c(2);
  const {
    pathname
  } = usePathname();
  let t0;
  if ($[0] !== pathname) {
    t0 = isCopilotFullscreenChatPath(pathname);
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};